module.exports = __webpack_public_path__ + "static/media/BountifulHarvest.89d6c439.jpg";